













































































































































































































import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api';
import { SfImage, SfLink, SfRating } from '@storefront-ui/vue';
import dayjs from 'dayjs';
import LazyHydrate from 'vue-lazy-hydration';

import { useUiHelpers } from '~/composables';
import { addBasePath } from '~/helpers/addBasePath';
import { useI18n } from '~/helpers/hooks/usei18n';
import ReviewsPagination from '~/modules/catalog/category/components/pagination/ReviewsPagination.vue';

export default defineComponent({
  name: 'Reviews',
  components: {
    SfRating,
    SfLink,
    LazyHydrate,
    ReviewsPagination,
    SfImage,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    product: {
      type: Object,
      required: true,
    },
    productreviewsrating: {
      type: Array,
      required: true,
    },
  },

  setup(props) {
    const reviews = ref<any>({});
    const { locale } = useI18n();

    const pagination = ref<any>({});
    const uiHelpers = useUiHelpers();
    const getReviews = async () => {
      const response = await fetch(
        `https://api.feefo.com/api/20/reviews/all?merchant_identifier=unineed-limited&product_sku=${props?.product?.sku}`
      );

      if (response) {
        const reviewsData = await response.json();
        reviews.value = reviewsData?.reviews;
        pagination.value = {
          currentPage: reviewsData?.summary?.meta?.current_page || 1,
          totalPages: reviewsData?.summary?.meta?.pages || 1,
          totalItems: reviewsData?.summary?.meta?.count || 0,
          itemsPerPage: reviewsData?.summary?.meta?.page_size || 20,
          pageOptions: [20, 30, 50, 100],
        };
      }
    };
    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      getReviews();
    };

    useFetch(() => {
      if (locale === 'gb' && props.product && props.product.sku) {
        getReviews();
      }
    });

    return {
      dayjs,
      reviews,
      pagination,
      goToPage,
      locale,
      addBasePath,
    };
  },
});
